import { Root, PopoverProps } from '@radix-ui/react-popover';
import { useState } from 'react';

import { noop } from 'utils/noop';

export interface CorePopoverProps extends PopoverProps {
  onOpenChange?: (open: boolean) => void;
}
export const Popover: React.FC<React.PropsWithChildren<CorePopoverProps>> = ({
  children,
  onOpenChange = noop,
  defaultOpen = false,
  ...rest
}) => {
  const [isPopoverOpen, togglePopoverOpen] = useState(defaultOpen);
  return (
    <Root
      open={isPopoverOpen}
      onOpenChange={(open: boolean) => {
        togglePopoverOpen(open);
        onOpenChange(open);
      }}
      {...rest}
    >
      {children}
    </Root>
  );
};
